var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',[_vm._l((_vm.items),function(item){return _c('Participant',{key:_vm.generateKey(item),attrs:{"participant":item,"show-user-status":_vm.showUserStatus},on:{"click-participant":_vm.handleClickParticipant}})}),_vm._v(" "),(_vm.loading)?_c('LoadingPlaceholder',{attrs:{"type":"participants","count":_vm.dummyParticipants}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }